import httpService from '../http.service';

const BASE_ROUTE = '/avatars';

function index(params = {}) {
  return httpService.get(BASE_ROUTE, params);
}

export default {
  index
};
